import { render, staticRenderFns } from "./Patients.vue?vue&type=template&id=0459e1e4&scoped=true"
import script from "./Patients.vue?vue&type=script&lang=js"
export * from "./Patients.vue?vue&type=script&lang=js"
import style0 from "./Patients.vue?vue&type=style&index=0&id=0459e1e4&prod&scoped=true&lang=css"
import style1 from "./Patients.vue?vue&type=style&index=1&id=0459e1e4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0459e1e4",
  null
  
)

export default component.exports